import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { VList, VBtn, VIcon, VSlider, VSpacer } from 'vuetify/lib'
import Ripple from 'vuetify/lib/directives/ripple';

Vue.use(Vuetify, {
  components: {
    VList, VBtn, VIcon, VSlider, VSpacer
  },
  directives: {
    Ripple,
  },
})

Vue.mixin({
  data: () => ({
    masks: {
      phone_number: "+998 (##) ### - ## - ##",
    },
    moneyOptions: {
      prefix: "",
      suffix: "",
      length: 11,
      decimal: ",",
      thousands: ",",
      precision: 0,
      masked: false,
    },
    moneyOptionsUSD: {
      prefix: "",
      suffix: "$",
      length: 11,
      decimal: ",",
      thousands: ",",
      precision: 2,
      masked: false,
    },
    quantityOptions: {
      length: 6,
      precision: 2,
      masked: false,
    },
    vueYandexShareOptions: {
      accessToken: null,
      bare: false,
      counter: false,
      copy: 'last',
      description: null,
      direction: 'vertical',
      hashtags: null,
      image: null,
      lang: 'ru',
      limit: 24,
      popupDirection: 'bottom',
      popupPosition: 'inner',
      size: 'm',
      title: null,
      url: null,
      services: [
        'telegram',
        'facebook',
        'skype',
        'twitter',
        'whatsapp',
      ],
    },
    currencies: [
      {
        text: 'UZS',
        value: 'uzs'
      },
      {
        text: 'USD',
        value: 'usd'
      }
    ],
    fieldRules: {
      required: value => !!value,
      require: value => !!value,
      requiredNumber: value => !!value,
      numberString: (length) => value => {
        if (!value) {
          return true
        }

        const regExp = length ? new RegExp(`(^$)|(^[0-9]{${length}}$)`) : new RegExp('(^$)|(^\\d+$)')
        if (regExp.test(value)) {
          return true
        }

        return length ? `Value must number and length must eq ${length}` : 'Value must number'
      },
      choose: value => !!value || "Choose",
      counter: value => value.length <= 20 || "Max 20 characters",
      phone: value => {
        const pattern = /^[0-9*]{9}$/;
        return pattern.test(value);
      },
      validPhone: (value) => {
        if (!value) {
          return 'Required'
        }
        const new_value = value.replace(/[^0-9]/g, "");
        if (new_value.length !== 12) {
          return 'Should be valid phone';
        }
        return true;
      },
      employeePhone: value => {
        let test_number = ''
        if (value) {
          test_number = value.replace('(', '').replace(')', '').replace(/ /g, '')
        }
        const pattern = /^\d{12}$/
        return pattern.test(test_number) || 'Please enter valid phone number';
      },
      employeeClock: value => {
        const pattern = /^\d{2}\w\d{2}$/
        return pattern.test(value) || 'Wrong clock';
      },
      employeePassword: value => {
        const pattern = /^(\d{4,6})$/
        if (value > 10000 && value <= 99999) {
          return 'Password must be 4 or 6 digit';
        }
        return pattern.test(value) || 'Password must be 4 or 6 digit';
      },
      employeeSuperPassword: value => {
        if (!value) {
          return true;
        }
        const pattern = /^\d{4}$/
        return pattern.test(value) || 'Password must be 4 digit';
      },
      inessentialEmail: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let valid = false
        if (!value) {
          valid = true
        }
        else {
          valid = pattern.test(value)
        }

        return valid || "Please enter valid email"
      },
      phone_number: value => {
        const pattern = /^(\d{3,})([(]{1}\d{1,3}[)]{0,}){0,}([\s|-]?\d+|\+\d{2,3}[\s|-]{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}([\s|-]){0,}$/;
        return pattern.test(value);
      },
      percent: v => v <= 100 || 'Percent should be smaller than 100',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Неверный e-mail";
      }
    },
    loadImageError: false,
    loadImageErrorMessage: '',
    loadedImagePath: ''
  }),
  computed: {
    user_access() {
      return this.$store.state.access
    },
    currentCurrency() {
      return this.$store.state.currentCurrency;
    },
    invan_user() {
      return this.$store.state.user
    },
    transfer_currencies() {
      return [
        {
          text: 'UZS',
          value: 'uzs'
        },
        {
          text: 'USD',
          value: 'usd'
        },
        {
          text: this.$t('transfer'),
          value: 'transfer'
        }
      ]
    },
    sold_by_options() {
      return [
        {
          text: this.$t('each'),
          value: 'each'
        },
        {
          text: this.$t('weight'),
          value: 'weight'
        },
        {
          text: this.$t('pcs'),
          value: 'pcs'
        },
        {
          text: this.$t('box'),
          value: 'box'
        },
        {
          text: this.$t('litre'),
          value: 'litre'
        },
        {
          text: this.$t('metre'),
          value: 'metre'
        },
      ]
    },
    no_clients_found() {
      return this.$t('no_clients_found')
    },
    no_stores_found() {
      return this.$t('no_stores_found')
    },
    currencyZeros() {
      try { return this.$store.state.currencyZeros }
      catch (error) {
        return 2
      }
    }
  },
  methods: {
    setLang() {
      this.fieldRules.employeeClock = value => {
        const pattern = /^\d{2}[:]\d{2}$/;
        return pattern.test(value) || this.$t('wrong_clock');
      }
      this.fieldRules.required = value => {
        if (!value) {
          return this.$t('this_field_can_not_be_blank')
        }
        if (typeof value == typeof 'invan') {
          value = value.trim(' ')
        }
        return !!value || this.$t('this_field_can_not_be_only_space')
      }
      this.fieldRules.require = value => {
        if (!value) {
          return ''
        }
        if (typeof value == typeof 'invan') {
          value = value.trim(' ')
        }
        return !!value
      }
      this.fieldRules.requiredNumber = value => {
        if (typeof value == typeof 5) {
          return true
        }
        return !!value
      }
      this.fieldRules.phone = value => {
        const pattern = /^[0-9]{9}$/;
        return pattern.test(value) || this.$t('wrong_phone')
      }
      this.fieldRules.acceptBarcode = value => {
        if (!value) {
          return this.$t('this_field_can_not_be_blank')
        }
        const pattern = /^[0-9]{5,}$/;
        return pattern.test(value) || this.$t('please_enter_valid_barcode')
      }
    },
    setZeros() {
      this.moneyOptionsUSD.precision = this.currencyZeros;
    },
    date_ddmmyy(timestamp) {
      if (typeof timestamp == typeof 5) {
        let day = new Date(timestamp).getDate()
        day = day < 10 ? `0${day}` : day
        let month = new Date(timestamp).getMonth()
        month = month < 9 ? `0${month + 1}` : (month + 1)
        let year = new Date(timestamp).getFullYear()
        return `${day}.${month}.${year}`
      }
      else return timestamp
    },
    date_ddmmyy_hhmm(timestamp) {
      if (typeof timestamp == typeof 5) {
        let day = new Date(timestamp).getDate()
        day = day < 10 ? `0${day}` : day
        let month = new Date(timestamp).getMonth()
        month = month < 9 ? `0${month + 1}` : (month + 1)
        let year = new Date(timestamp).getFullYear()
        let hour = new Date(timestamp).getHours()
        hour = hour < 10 ? `0${hour}` : hour
        let minutes = new Date(timestamp).getMinutes()
        minutes = minutes < 10 ? `0${minutes}` : minutes
        return `${day}.${month}.${year} ${hour}:${minutes}`
      }
      else return timestamp
    },
    date_hhmm(timestamp) {
      if (typeof timestamp == typeof 5) {
        let hour = new Date(timestamp).getHours()
        hour = hour < 10 ? `0${hour}` : hour
        let minutes = new Date(timestamp).getMinutes()
        minutes = minutes < 10 ? `0${minutes}` : minutes
        return `${hour}:${minutes}`
      }
      else return timestamp
    },
    rountIt(value, type = "no_round") {
      switch (type) {
        case 'round_50': {
          return Math.floor(value / 100) * 100 + 50;
        }
        case 'round_500': {
          return Math.floor(value / 1000) * 1000 + 500;
        }
        default: {
          return value;
        }
      }
    },
    converter(str) {
      if (typeof str != typeof 'invan') {
        str = ''
      }
      var convert = {
        "G'": "Ғ",
        "g'": "ғ",
        "o'": "ў",
        "O'": "Ў",
        "G`": "Ғ",
        "g`": "ғ",
        "o`": "ў",
        "O`": "Ў",
        "'": "ъ",
        "`": "ъ",
        "ye": "е",
        "Ye": "Е",
        "yu": "ю",
        "Yu": "Ю",
        "YU": "Ю",
        "ya": "я",
        "YA": "Я",
        "Ya": "Я",
        "yo": "ё",
        "Yo": "Ё",
        "YO": "Ё",
        "b": "б",
        "ch": "ч",
        "ts": "ц",
        "sh": "ш",
        "shch": "щ",
        "y": "ы",
        "iu": "ю",
        "a": "а",
        "c": "ц",
        "d": "д",
        "e": "е",
        "f": "ф",
        "g": "г",
        "h": "х",
        "i": "и",
        "j": "ж",
        "k": "к",
        "l": "л",
        "m": "м",
        "n": "н",
        "o": "о",
        "p": "п",
        "q": "қ",
        "r": "р",
        "s": "с",
        "t": "т",
        "u": "у",
        "v": "в",
        "w": "уа",
        "x": "кс",
        "z": "з",
        "B": "Б",
        "CH": "Ч",
        "TS": "Ц",
        "SH": "Ш",
        "SHCH": "Щ",
        "IU": "Ю",
        "A": "А",
        "C": "Ц",
        "D": "Д",
        "E": "Е",
        "F": "Ф",
        "G": "Г",
        "H": "Х",
        "I": "И",
        "J": "Ж",
        "K": "К",
        "L": "Л",
        "M": "М",
        "N": "Н",
        "O": "О",
        "P": "П",
        "Q": "Қ",
        "R": "Р",
        "S": "С",
        "T": "Т",
        "U": "У",
        "V": "В",
        "W": "УА",
        "X": "КС",
        "Y": "Й",
        "Z": "З",
        'Ғ': 'G`',
        'ғ': 'g`',
        'ў': 'o`',
        'Ў': 'O`',
        'ъ': '`',
        'е': 'e',
        'Е': 'E',
        'ю': 'iu',
        'Ю': 'IU',
        'я': 'ya',
        'Я': 'Ya',
        'ё': 'yo',
        'Ё': 'YO',
        'б': 'b',
        'ч': 'ch',
        'ц': 'c',
        'ш': 'sh',
        'щ': 'shch',
        'й': 'y',
        'а': 'a',
        'д': 'd',
        'ф': 'f',
        'г': 'g',
        'х': 'h',
        'и': 'i',
        'ж': 'j',
        'к': 'k',
        'л': 'l',
        'м': 'm',
        'н': 'n',
        'о': 'o',
        'п': 'p',
        'қ': 'q',
        'р': 'r',
        'с': 's',
        'т': 't',
        'у': 'u',
        'в': 'v',
        'уа': 'w',
        'кс': 'x',
        'з': 'z',
        'Б': 'B',
        'Ч': 'CH',
        'Ц': 'C',
        'Ш': 'SH',
        'Щ': 'SHCH',
        'Й': 'Y',
        'А': 'A',
        'Д': 'D',
        'Ф': 'F',
        'Г': 'G',
        'Х': 'H',
        'И': 'I',
        'Ж': 'J',
        'К': 'K',
        'Л': 'L',
        'М': 'M',
        'Н': 'N',
        'О': 'O',
        'П': 'P',
        'Қ': 'Q',
        'Р': 'R',
        'С': 'S',
        'Т': 'T',
        'У': 'U',
        'В': 'V',
        'УА': 'W',
        'КС': 'X',
        'З': 'Z'
      }
      var answer = ''
      for (let i = 0; i < str.length; i++) {
        if (typeof convert[str[i]] == typeof 'invan')
          answer = answer + convert[str[i]]
      }
      return answer != '' ? answer : 'nothing_to_change'
    },
    async UploadImage(e) {
      this.loadImageErrorMessage = '';
      this.loadImageError = false;
      this.loadedImagePath = '';
      if (e && e.target && e.target.files && e.target.files[0]) {
        try {
          var res = await this.$communicator.file(
            "upload",
            {
              file: e.target.files[0],
            },
            true
          );
          this.loadedImagePath =
            `${this.$communicator.base_url}static/` + res.data.data.path;
        } catch (error) {
          this.loadImageErrorMessage = error.message;
          this.loadImageError = true
        }
      }
    },
    async UploadImage1(file) {
      this.loadImageErrorMessage = '';
      this.loadImageError = false;
      this.loadedImagePath = '';
      if (file.name) {
        try {
          var res = await this.$communicator.file(
            "upload",
            {
              file: file,
            },
            true
          );
          this.loadedImagePath =
            `${this.$communicator.base_url}static/` + res.data.data.path;
        } catch (error) {
          this.loadImageErrorMessage = error.message;
          this.loadImageError = true
        }
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    roundMoney(value, count = 2) {
      if (typeof value != 'number') return value;
      return Math.round(value * Math.pow(10, count)) / Math.pow(10, count)
    },
    getItemSearchText(item) {
      let search_text = ''
      try {
        search_text =
          item.name +
          this.converter(item.name) +
          item.sku;

        if (typeof item.barcode_by_type === "string") {
          search_text += item.barcode_by_type;
        }
        if (item.barcode instanceof Array) {
          for (const b of item.barcode) {
            search_text += b
          }
        }
      } catch (error) {
        return ''
      }
      return search_text;
    },
    has_count_by_type_item(item) {
      return item.sold_by == 'box' || item.sold_by == 'pcs';
    },
    has_not_count_by_type_item(item) {
      return item.sold_by != 'box' && item.sold_by != 'pcs';
    },
  },
  mounted: function () {
    this.setLang()
  },
  beforeMount() {
    this.setZeros();
  }
})

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#3e6187',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#3e6187',
        warning: '#FFC107'
      },
    },
  },
});
